/**
 * Warehouse Form Field Constants
 * Standardized field names for warehouse forms to avoid naming inconsistencies
 */

// Warehouse basic information fields
export const WAREHOUSE_NAME_KANJI = 'warehouseNameKanji';
export const WAREHOUSE_NAME_FURIGANA = 'warehouseNameFurigana';

// Contact information fields
export const CONTACT_EMAIL = 'contactEmail';
export const PHONE = 'phone';
export const FAX = 'fax';

// Address information fields
export const POSTAL_CODE = 'postalCode';
export const POSTAL_CODE_1 = 'postalCode1';
export const POSTAL_CODE_2 = 'postalCode2';
export const PREFECTURE = 'prefecture';
export const ADDRESS = 'address';
export const BUILDING = 'building';

// Additional information fields
export const REMARKS = 'remarks';

// API parameter names
export const MNG_ID = 'mng_id';
export const WAREHOUSE_ID = 'warehouse_id';

// Form data field names (matching form structure)
export const FORM_FIELDS = {
    // Basic warehouse info
    WAREHOUSE_NAME_KANJI,
    WAREHOUSE_NAME_FURIGANA,

    // Contact info
    CONTACT_EMAIL,
    PHONE,
    FAX,

    // Address info
    POSTAL_CODE,
    PREFECTURE,
    ADDRESS,
    BUILDING,

    // Additional info
    REMARKS
};

export const FORM_FIELD_LABELS = {
    WAREHOUSE_NAME_KANJI: '倉庫名',
    WAREHOUSE_NAME_FURIGANA: '倉庫名（ふりがな）',
    CONTACT_EMAIL: 'ご連絡先メールアドレス',
    PHONE: 'TEL',
    FAX: 'FAX',
    POSTAL_CODE: '郵便番号',
    PREFECTURE: '都道府県',
    ADDRESS: '住所',
    BUILDING: 'ビル等',
    REMARKS: '備考'
};

// Error field IDs (matching error display mapping)
export const ERROR_FIELD_IDS = {
    ...Object.keys(FORM_FIELDS).reduce((acc, field) => {
        acc[field] = `${field}Error`;
        return acc;
    }, {}),
    // Add phone field parts mapping
    [`${PHONE}1`]: 'phoneError',
    [`${PHONE}2`]: 'phoneError',
    [`${PHONE}3`]: 'phoneError',
    // Add postal code field parts mapping
    [`${POSTAL_CODE}1`]: 'postalCodeError',
    [`${POSTAL_CODE}2`]: 'postalCodeError',
    // Add fax field parts mapping
    [`${FAX}1`]: 'faxError',
    [`${FAX}2`]: 'faxError',
    [`${FAX}3`]: 'faxError'
};
